import React from "react";
import UnexpectedExpensesContainer from "../../containers/UnexpectedExpenses";

function UnexpectedExpenses(props) {
  return <UnexpectedExpensesContainer {...props} />;
}

export default UnexpectedExpenses;
